const BODY_OVERFLOW_HIDDEN = 'body--overflow-hidden'

export default BODY_OVERFLOW_HIDDEN